const ContractOrderIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_3336_25275)">
            <path d="M18 4H6C4.34315 4 3 5.34315 3 7V17C3 18.6569 4.34315 20 6 20H18C19.6569 20 21 18.6569 21 17V7C21 5.34315 19.6569 4 18 4Z" stroke="#21272A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M9 12C10.1046 12 11 11.1046 11 10C11 8.89543 10.1046 8 9 8C7.89543 8 7 8.89543 7 10C7 11.1046 7.89543 12 9 12Z" stroke="#21272A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M15 8H17" stroke="#21272A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M15 12H17" stroke="#21272A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M7 16H17" stroke="#21272A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_3336_25275">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
)

export default ContractOrderIcon
